<script setup>
import {computed, defineAsyncComponent, onMounted} from "vue";
  import { useCardsStore } from '@/store/stores/cards'
  const cardsStore = useCardsStore()

  // components block
  const BaseLoader = defineAsyncComponent (() => import(/* webpackChunkName: "components/base/BaseLoader" */ '@/components/base/BaseLoader.vue'));
  const CardsList = defineAsyncComponent (() => import(/* webpackChunkName: "views/cards/CardsList" */ '@/views/cards/CardsList.vue'));
  const EmptyCardsList = defineAsyncComponent (() => import(/* webpackChunkName: "views/cards/EmptyCardsList" */ '@/views/cards/EmptyCardsList.vue'));

  const cards = computed(() => {
    return cardsStore.getCards
  })

  onMounted(() => {
    if (!cardsStore.getCards) {
      cardsStore.fetchCards();
    }
  })
</script>

<template>
  <div class="cards-page__wrapper">
    <template v-if="!cards">
      <BaseLoader />
    </template>
    <template v-else-if="!cards.length">
      <EmptyCardsList />
    </template>
    <div v-else class="cards-list">
      <CardsList :list="cards" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .cards-page {
    &__wrapper {
      height: calc(100dvh - 167px);
      //min-height: 765px;
      padding: 24px;

      overflow: auto;

      .cards-list {

      }
    }
  }
</style>